import React, { useState, useEffect } from "react";
import { useData } from "../../../components/firebase/DataProvider";
import { firefunctions } from "../../../components/firebase/FirebaseProvider";
import useStyles from "./style";
import TokorameIcon from "../../../assets/logo-tokorame.svg";
import Footer from "../../../components/molecules/LoginNav/footer";
import {
  AppBar,
  Button,
  // Button,
  Container,
  Grid,
  Paper,
  Toolbar,
} from "@material-ui/core";
import MaterialTable from "material-table";
import AppLoading from "../../../components/appLoading";
import tableIcons from "../../../components/tableicon/table-icons";
import { date } from "../../../utils/dateTime";
import ExcelFile from "@ibrahimrahmani/react-export-excel/dist/ExcelPlugin/components/ExcelFile";
import ExcelSheet from "@ibrahimrahmani/react-export-excel/dist/ExcelPlugin/elements/ExcelSheet";
import ExcelColumn from "@ibrahimrahmani/react-export-excel/dist/ExcelPlugin/elements/ExcelColumn";

function DataJaringan() {
  const { profil } = useData();
  const classes = useStyles();
  // const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  // console.log(data);
  const [table, setTable] = useState({
    columns: [
      {
        title: "Created at",
        field: "created_at",
        render: (rowData) => (
          <>
            {rowData && rowData.created_at !== null ? (
              <span>{date(rowData.created_at)}</span>
            ) : (
              <span>-</span>
            )}
          </>
        ),
      },
      {
        title: "Nama",
        field: "nama",
      },
      {
        title: "Nama Toko",
        field: "nama_toko",
      },
      { title: "Subdomain", field: "subdomain" },
      { title: "Nomer Wa", field: "wa" },
      { title: "Tipe Akun", field: "tipe_akun" },
      { title: "Kode Referral", field: "kode_referral" },
    ],
    data: [],
  });

  const getData = async () => {
    setLoading(true);

    try {
      const func = firefunctions.httpsCallable("getJaringan");
      const data = {
        user_id: profil?.id,
      };
      const res = await func(data);
      // setData(res?.data ?? []);
      setTable((table) => {
        const obj = {
          ...table,
          data: res?.data
            ? res?.data.map((doc) => {
                return {
                  ...doc,
                };
              })
            : [],
        };
        return obj;
      });
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  if (loading) {
    return <AppLoading />;
  }

  return (
    <Grid container xs={12}>
      <Paper className={classes.paperWrap}>
        <AppBar position="static">
          <Toolbar>
            <div className={classes.wrapHeader}>
              <div className={classes.wrapIcon}>
                <img src={TokorameIcon} alt="tokorame" />
              </div>
              <ExcelFile
                filename="Data All Team"
                element={
                  <Button variant="contained" size="small">
                    Export To Excel
                  </Button>
                }
              >
                <ExcelSheet data={table.data} name="Data All Team">
                  <ExcelColumn
                    label="Created at"
                    value={(col) => date(col.created_at)}
                  />
                  <ExcelColumn label="Nama" value="nama" />
                  <ExcelColumn label="Nama Toko" value="nama_toko" />
                  <ExcelColumn label="Subdomain" value="subdomain" />
                  <ExcelColumn label="Nomer Wa" value="wa" />
                  <ExcelColumn label="Tipe Akun" value="tipe_akun" />
                  <ExcelColumn label="Kode Referral" value="kode_referral" />
                </ExcelSheet>
              </ExcelFile>
            </div>
          </Toolbar>
        </AppBar>
        <div className={classes.pageWrapWrap}>
          <div className={classes.content}>
            <div className={classes.root}>
              <Container>
                <MaterialTable
                  columns={table.columns}
                  data={table.data}
                  title="Data All Team"
                  icons={tableIcons}
                  options={{
                    pageSize: 5,
                    pageSizeOptions: [5, 10, 25, 50, 100],
                    headerStyle: {
                      fontWeight: "bold",
                    },
                  }}
                  localization={{
                    body: {
                      emptyDataSourceMessage: "Tidak Ada Data",
                    },
                    toolbar: {
                      searchTooltip: "Cari",
                      searchPlaceholder: "Cari Data",
                    },
                    header: {
                      actions: "Actions",
                    },
                    pagination: {
                      labelRowsSelect: "Baris",
                      labelDisplayedRows: " {from}-{to} Dari {count} Baris",
                      firstTooltip: "Halaman Pertama",
                      previousTooltip: "Halaman Sebelumnya",
                      nextTooltip: "Halaman Selanjutnya",
                      lastTooltip: "Halaman Terakhir",
                    },
                  }}
                />
              </Container>
            </div>
          </div>
        </div>
        <Footer />
      </Paper>
    </Grid>
  );
}

export default DataJaringan;
